import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { track } from '@vercel/analytics';
import data from '../data.json';

const emptyForm = {
  name: "",
  email: "",
  phone: "",
  company: "",
  service: "",
  message: "",
};

const inputClassName =
  "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline";

const ContactForm = () => {
  const [formData, setFormData] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState("");
  const form = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let tempErrors = {};
    if (!formData.name.trim()) tempErrors.name = "Name is required";
    if (!formData.email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Email is invalid";
    }
    if (!formData.message.trim()) tempErrors.message = "Message is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      emailjs
        .sendForm('service_wqrytv5', 'template_6p86hhe', form.current, {
          publicKey: 'SV3RbgfXn5x45luCT',
        })
        .then(
          () => {
            console.log('SUCCESS!');
            setSubmitStatus("success");
            track('Contact Submitted');
            setFormData(emptyForm);
          },
          (error) => {
            console.log('FAILED...', error.text);
            setSubmitStatus("error");
          },
        );
    } else {
      setSubmitStatus("error");
    }
  };

  return (
    <form ref={form} className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-md shadow-md rounded-lg p-8" onSubmit={handleSubmit}>
      {submitStatus === "success" && (
        <div className="mb-4 text-green-400 font-bold">
          Thank you for your message. We'll get back to you within 24 hours!
        </div>
      )}
      <div className="mb-4">
        <label className="block text-white text-sm font-bold mb-2" htmlFor="name">
          Name
        </label>
        <input
          className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
            errors.name ? "border-red-500" : ""
          }`}
          id="name"
          type="text"
          placeholder="Your Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />
        {errors.name && (
          <p className="text-red-500 text-xs italic">{errors.name}</p>
        )}
      </div>
      <div className="mb-4">
        <label className="block text-white text-sm font-bold mb-2" htmlFor="email">
          Email *
        </label>
        <input
          className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
            errors.email ? "border-red-500" : ""
          }`}
          id="email"
          type="email"
          placeholder="Your Email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        {errors.email && (
          <p className="text-red-500 text-xs italic">{errors.email}</p>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-white text-sm font-bold mb-2" htmlFor="phone">
            Phone
          </label>
          <input
            className={inputClassName}
            id="phone"
            type="tel"
            placeholder="Your Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
        <div>
          <label className="block text-white text-sm font-bold mb-2" htmlFor="company">
            Company
          </label>
          <input
            className={inputClassName}
            id="company"
            type="text"
            placeholder="Your Company"
            name="company"
            value={formData.company}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="mb-4">
        <label className="block text-white text-sm font-bold mb-2" htmlFor="service">
          Service Needed
        </label>
        <select
          className={`${inputClassName} bg-white`}
          id="service"
          name="service"
          value={formData.service}
          onChange={handleChange}
        >
          <option value="">Select a service</option>
          {data.servicesList.map((service) => (
            <option key={service.id} value={service.heading}>
              {service.heading}
            </option>
          ))}
          <option value="Other">Other</option>
        </select>
      </div>
      <div className="mb-6">
        <label className="block text-white text-sm font-bold mb-2" htmlFor="message">
          Message
        </label>
        <textarea
          className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-32 ${
            errors.message ? "border-red-500" : ""
          }`}
          id="message"
          placeholder="Your Message"
          name="message"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        {errors.message && (
          <p className="text-red-500 text-xs italic">{errors.message}</p>
        )}
      </div>
      <div className="flex items-center justify-center">
        <button
          className="w-full bg-custom-blue hover:bg-custom-red text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300"
          type="submit"
        >
          Send
        </button>
      </div>
    </form>
  );
};

export default ContactForm;